<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-row :gutter="10" style="margin-bottom:10px">
                    <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">关联编号</span>
                        <el-input size="mini" v-model="searchParam.relNo" label="订单编号" placeholder="订单编号/退款编号" clearable @clear="searchParam.relNo = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">调用接口</span>
                        <el-select size="mini" v-model="searchParam.api" clearable placeholder="请选择" class="handle-select" >
                            <el-option key="1" label="查询订单" value="query"></el-option>
                            <el-option key="2" label="业务处理" value="business"></el-option>
                            <el-option key="3" label="关闭订单" value="close"></el-option>
                            <el-option key="4" label="申请退款" value="refund"></el-option>
                            <el-option key="5" label="退款查询" value="refundQuery"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="8">
                        <span class="label">创建时间</span>
                        <el-date-picker
                            size="mini"
                            style="width:200px"
                            v-model="searchParam.startTime"
                            type="datetime"
                            placeholder="开始时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                        <span class="label" style="margin:0 5px;">至</span>
                        <el-date-picker
                            size="mini"
                            style="handle-input"
                            v-model="searchParam.endTime"
                            type="datetime"
                            placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-row type="flex"  justify="end">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                </el-row> 
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" ref="multipleTable" :max-height="tableLen">
                <el-table-column prop="relNo" label="关联编号"  width="290" fixed="left"></el-table-column>
                <!-- <el-table-column prop="api" label="调用接口"  width="150" fixed="center"></el-table-column> -->
                <el-table-column prop="api" label="调用接口" width="150" align="center">
                    <template slot-scope="scope">
                        <el-tag  v-if="scope.row.api === 'query'" type="info" disable-transitions>查询订单</el-tag>
                        <el-tag  v-if="scope.row.api === 'business'" type="info" disable-transitions>业务处理</el-tag>
                        <el-tag  v-if="scope.row.api === 'close'" type="info" disable-transitions>关闭订单</el-tag>
                        <el-tag  v-if="scope.row.api === 'refund'" type="info" disable-transitions>申请退款</el-tag>
                        <el-tag  v-if="scope.row.api === 'refundQuery'" type="info" disable-transitions>退款查询</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="code" label="通讯code" width="150" align="center"></el-table-column>
                <el-table-column prop="msg" label="通讯msg" width="150" align="center"></el-table-column>
                <el-table-column prop="businessCode" label="业务code" width="150" align="center"></el-table-column>
                <el-table-column prop="errCode" label="错误code" width="150" align="center"></el-table-column>
                <el-table-column prop="errMsg" label="错误msg" width="150" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150" align="center"></el-table-column>
                <el-table-column prop="remark" label="备注" align="left"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
                </el-pagination>
            </div>

         
            
        </div>
    </div>
</template>

<script>
    export default {
        name:'orderException',
        data() {
            return {
                tableLen:350,
                searchParam:{
                    pageNum:1, 
                    pageSize:10,
                },
                tableData:[],
                totalNumber:0,
            };
        },
        created(){
            this.getData();
        },
        updated() {
            this.tableLen=window.innerHeight-135;
        },
        methods: {
            async getData(){
                let res = await this.$axios.post('/manage/order/exception/selectByPage',this.searchParam);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.tableData = res.data.list;
                this.totalNumber = res.data.total;
            },
           
        }
    };
</script>

<style scoped>
.handle-box {
    margin-bottom: 10px;
}
.el-col{
    margin: 10px 0;
}
/* .handle-select {
    width: 200px;
}

.handle-input {
    width: 200px;
} */
.label {
    margin-right: 10px;
    color: #606266;
}
</style>
